import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PlatformType } from 'src/environments/platform-type.enum';

@Component({
    selector: 'app-icon-vendors',
    templateUrl: './icon-vendors.component.html',
    styleUrls: ['./icon-vendors.component.scss']
})
export class IconVendorsComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    currentPlatform = environment.platformId;
    PlatformType = PlatformType;

    constructor() { }

    ngOnInit() {
    }

}
